export default __webpack_public_path__ + "static/media/icon_crown_white.86b05d88.svg";